import { memo, type FC } from "react";
import { PressableScale } from "pressto";
import { useUnistyles, StyleSheet } from "react-native-unistyles";
import { View, Text } from "@src/components";
import { Icon, type IconNameType } from "@src/components/Icon";

export interface ManageOption {
  id: string;
  title: string;
  description: string;
  icon: IconNameType;
  onPress?: () => void;
}

interface ManageOptionsListProps {
  options: ManageOption[];
}

export const ManageOptionsList: FC<ManageOptionsListProps> = memo(({ options }) => {
  const { theme } = useUnistyles();

  return (
    <View gap="lg">
      {options.map((option) => (
        <PressableScale key={option.id} onPress={option.onPress}>
          <View gap="md" py="5xl" px="3xl" style={styles.card}>
            <View flexDirection="row" alignItems="center" gap="xs">
              <Icon name={option.icon} color={theme.colors.icon} />
              <View style={{ flex: 1 }}>
                <Text textStyle="sm/medium">{option.title}</Text>
              </View>
              <Icon name="chevronRight" size={20} color={theme.colors.textMuted} />
            </View>
            <View>
              <Text textStyle="xs/regular" color="textMuted">
                {option.description}
              </Text>
            </View>
          </View>
        </PressableScale>
      ))}
    </View>
  );
});

const styles = StyleSheet.create((theme) => ({
  card: {
    borderWidth: 1,
    borderColor: theme.colors.borderCard,
    borderRadius: theme.spacing.md,
  },
}));
